<template>
    <div>
        <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
        <div v-else-if="stock">
            <ValidationObserver ref="stockform">
                <form @submit.prevent="saveStock">
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="card">
                                <div class="card-header header-elements-inline bg-info py-2">
                                    <h5 class="card-title text-white">Lagersaldo hos Supékort</h5>
                                    <div class="header-elements">
                                        <button type="button" class="btn btn-light" @click="showModalStockLabel">SKRIV UT LAGERETIKETT</button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-4">
                                            <div class="form-group mb-0">
                                                <label>Totalt Saldo</label>
                                                <input type="text" class="form-control" :value="stock.Stock_today" disabled>
                                            </div>
                                        </div>
                                        <!--                                        <div class="col-xl-4">-->
                                        <!--                                            <div class="form-group mb-0">-->
                                        <!--                                                <label>Reserverat</label>-->
                                        <!--                                                <input type="text" class="form-control" :value="stock.Stock_reserved" disabled>-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->
                                        <div class="col-xl-4">
                                            <div class="form-group mb-0">
                                                <label>Disponibelt</label>
                                                <input type="text" class="form-control" :value="stock.Stock_future" disabled>
                                            </div>
                                        </div>
                                        <div v-if="!stock.isStruct" class="col-xl-4">
                                            <div class="form-group mb-0">
                                                <label>Justera</label>
                                                <div class="input-group flex-nowrap">
                                                    <input type="text" class="form-control" :ref="'new-warehouse-stock-1'">
                                                    <span class="input-group-append">
                                                        <limitless-button btn-class="btn-info" @click="adjustStock(1)" :ref="'btnadjustwarehousestock-1'" saved-text="Justerat!">Justera</limitless-button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-if="stock.isStruct">
                                    <div class="alert alert-info alert-styled-left mb-0">
                                        <span class="text-semibold">OBS!</span> Detta är en strukturartikel. Lagersaldot justeras på någon av de produkter som denna består av.
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header header-elements-inline py-2" :class="{ 'bg-success': stock.useStockCounts, 'bg-warning': !stock.useStockCounts}">
                                    <div class="card-title text-white">
                                        <div class="custom-control custom-checkbox custom-control-inline mr-4">
                                            <input type="checkbox" class="custom-control-input" id="chk-auto-stock" v-model="stock.useStockCounts" :true-value="1" :false-value="0">
                                            <label class="custom-control-label" for="chk-auto-stock">Lagersaldouträkning aktiverad</label>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="stock.useStockCounts" class="card-body">
                                    <div class="mb-1">Om disp. lagersaldo &lt;&#61;
                                        <ValidationProvider tag="span" vid="autoblocklevel" name="autoblocklevel" v-slot="{ errors }">
                                            <input type="text" class="form-control d-inline-block" v-model="stock.autoblocklevel" style="width: 80px;">
                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div>
                                        sätt status
                                        <div style="width: 165px; display: inline-block;">
                                            <ValidationProvider tag="div" vid="autoblockfunction" name="Autoblockfunction" v-slot="{ errors }">
                                                <v-select
                                                    v-model="stock.autoblockfunction"
                                                    :options="[{id: 'isOutOfStock', label: 'Tillfälligt slut'}, {id: 'isPhasedOut', label: 'Utgått'}]"
                                                    :reduce="(opt) => opt.id"
                                                ></v-select>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        och åter i lager
                                        <div style="width: 165px; display: inline-block;">
                                            <v-date-picker v-model="stock.autoblock_backinstockdate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div class="input-group">
                                                        <input class="form-control" :value="inputValue" @focus="togglePopover()" placeholder="-- Välj datum --">
                                                        <span class="input-group-append">
                                                            <button class="btn btn-light px-1" type="button" @click="stock.autoblock_backinstockdate = ''"><i class="icon-cross3"></i></button>
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header header-elements-inline py-2 bg-white">
                                    <h5 class="card-title">Lagerstatus</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-5 d-flex align-items-center" style="height: 39px; width: 280px;">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-phased-out" v-model="stock.isPhasedOut" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-phased-out">Produkten har utgått ur sortimentet</label>
                                            </div>
                                        </div>
                                        <div class="col-xl-7">
                                            <div class="d-flex">
                                                <div class="col-form-label" style="width: 150px;">Ersättningsprodukt: </div>
                                                <div class="flex-grow-1">
                                                    <product-filter
                                                        v-model="stock.PhaseOutReplacement"
                                                        :reduce="(p) => p.ProdID"
                                                        placeholder="Välj..."
                                                    >
                                                    </product-filter>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-5 d-flex align-items-center" style="height: 39px;">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-out-of-stock" v-model="stock.isOutOfStock" :true-value="1" :false-value="0" :disabled="stock.useStockCounts > 0">
                                                <label class="custom-control-label" for="chk-out-of-stock">Tillfälligt slut
                                                    <span v-if="stock.useStockCounts">
                                                        <i class="icon-question3 text-danger ml-2" id="warning-out-of-stock"></i>
                                                        <b-popover key="warning-out-of-stock" target="warning-out-of-stock" triggers="hover focus">
                                                            <span>Kan ej ändras när automatisk lagersaldouträkning är aktiverat. Uppdateras automatiskt baserat på disponibelt saldo var 15:e minut.</span>
                                                        </b-popover>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-7">
                                            <div class="d-flex">
                                                <div class="col-form-label" style="width: 150px;">Beräknad åter i lager: </div>
                                                <div class="flex-grow-1">
                                                    <v-date-picker v-model="stock.BackInStockDate" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <div class="input-group">
                                                                <input class="form-control" :value="inputValue" @focus="togglePopover()" placeholder="-- Välj datum --">
                                                                <span class="input-group-append">
                                                                    <button class="btn btn-light px-1" type="button" @click="stock.BackInStockDate = ''"><i class="icon-cross3"></i></button>
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </v-date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-5 d-flex align-items-center" style="height: 39px;">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-non-stock-item" v-model="stock.isNonStockItem" :true-value="1" :false-value="0" :disabled="stock.useStockCounts > 0">
                                                <label class="custom-control-label" for="chk-non-stock-item">
                                                    Beställningsvara
                                                    <span v-if="stock.useStockCounts">
                                                        <i class="icon-question3 text-danger ml-2" id="warning-non-stock-item"></i>
                                                        <b-popover key="warning-out-of-stock" target="warning-non-stock-item" triggers="hover focus">
                                                            <span>Kan ej ändras när automatisk lagersaldouträkning är aktiverat</span>
                                                        </b-popover>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-xl-5 d-flex align-items-center" style="height: 39px;">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-no-refill" v-model="stock.no_refill" :true-value="1" :false-value="0" :disabled="stock.isNonStockItem > 0">
                                                <label class="custom-control-label" for="chk-no-refill">
                                                    Vänta med beställningar/Ej refill
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-xl-5">
                                            <ValidationProvider tag="div" vid="ReorderingPoint" name="Beställningspunkt" v-slot="{ errors }">
                                                <label>Beställningspunkt</label>
                                                <input type="number" class="form-control" v-model="stock.ReorderingPoint" min="0" step="1" :class="{ 'border-danger': errors[0] }">
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-xl-7 d-flex align-items-center" style="height: 64px; padding-top: 25px;">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="chk-reordering-acknowledged"
                                                    v-model="stock.ReorderingAcknowledgedTS"
                                                    :true-value="(stock.ReorderingAcknowledgedTS ? stock.ReorderingAcknowledgedTS : new Date().toLocaleString('sv-SE'))"
                                                    :false-value="null"
                                                >
                                                <label class="custom-control-label" for="chk-reordering-acknowledged">
                                                    Stäng av beställningspåminnelse<span v-if="stock.ReorderingAcknowledgedTS" class="text-muted ml-1">({{ stock.ReorderingAcknowledgedTS }})</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header header-elements-inline py-2 bg-white">
                                    <h5 class="card-title">Produkttyp & Frakt</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-6">
                                            <ValidationProvider tag="div" vid="ProductTypeID" name="Produkttyp" rules="required" v-slot="{ errors }" class="form-group">
                                                <label>Produkttyp</label>
                                                <product-type-filter
                                                    :reduce="(opt) => opt.id"
                                                    v-model="stock.ProductTypeID"
                                                    @option:selected="prodTypeSelected"
                                                    :clearable="false"
                                                >
                                                </product-type-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-xl-6" v-if="stock.ProductTypeID === 10">
                                            <ValidationProvider tag="div" vid="ProductCodeTypeID" name="Kodtyp" rules="" v-slot="{ errors }" class="form-group">
                                                <label>Kodtyp</label>
                                                <product-codes-types-filter
                                                    :reduce="(opt) => opt.id"
                                                    v-model="stock.ProductCodeTypeID"
                                                    :clearable="false"
                                                >
                                                </product-codes-types-filter>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-xl-6" v-if="uses_subproduct_selection">
                                            <ValidationProvider tag="div" vid="no_of_subproducts" name="Antal subprodukter" rules="required|integer|min_value:1" v-slot="{ errors }" class="form-group">
                                                <label>Antal subprodukter</label>
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    min="1"
                                                    step="1"
                                                    v-model="stock.no_of_subproducts"
                                                    :class="{ 'border-danger': errors[0] }"
                                                >
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Fraktsätt</label>
                                        <div>
                                            <div class="custom-control custom-checkbox custom-control-inline mr-4">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="chk-freight-1"
                                                    v-model="stock.allowed_deliv_types[1]"
                                                    :disabled="!stock.type.allowed_shipping_methods.includes('DPD')"
                                                >
                                                <label class="custom-control-label" for="chk-freight-1">MyPack Home<span class="text-muted ml-1">P17+PUK</span></label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline mr-4">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="chk-freight-2"
                                                    v-model="stock.allowed_deliv_types[2]"
                                                    :disabled="!stock.type.allowed_shipping_methods.includes('postoffice')"
                                                >
                                                <label class="custom-control-label" for="chk-freight-2">MyPack Collect<span class="text-muted ml-1">P19</span></label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline mr-4">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="chk-freight-8"
                                                    v-model="stock.allowed_deliv_types[8]"
                                                    :disabled="!stock.type.allowed_shipping_methods.includes('postal')"
                                                >
                                                <label class="custom-control-label" for="chk-freight-8">Varubrev<span class="text-muted ml-1">PUA</span></label>
                                            </div>
                                            <div class="custom-control custom-checkbox custom-control-inline">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    id="chk-freight-4"
                                                    v-model="stock.allowed_deliv_types[4]"
                                                    :disabled="!stock.type.allowed_shipping_methods.includes('online')"
                                                >
                                                <label class="custom-control-label" for="chk-freight-4">Online</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="row"
                                        v-if="!(stock.type.allowed_shipping_methods.length === 1 && stock.type.allowed_shipping_methods[0] === 'online')"
                                    >
                                        <div class="col-xl-6">
                                            <ValidationProvider tag="div" class="form-group" vid="sendByMail" name="Utskriftstyp" v-slot="{ errors }">
                                                <label>Utskriftstyp</label>
                                                <v-select
                                                    v-model="stock.sendByMail"
                                                    :options="[{id: 0, label: 'Unifaun Batchning'}, {id: 1, label: 'Vanligt Brev (Ptouch)'}, {id: 2, label: 'Pocketbatchning'}]"
                                                    :reduce="(opt) => opt.id"
                                                ></v-select>
                                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div v-if="stock.ProductTypeID === 13">
                                        <label>Flaggor</label>
                                        <div class="row">
                                            <div class="col-xl-6">
                                                <div class="custom-control custom-checkbox mb-2" v-if="stock.ProductTypeID === 13">
                                                    <input type="checkbox" class="custom-control-input" id="chk-delivery-frozen" v-model="stock.isFrozen">
                                                    <label class="custom-control-label" for="chk-delivery-frozen">Produkten skickas fryst</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header header-elements-inline py-2 bg-white">
                                    <h5 class="card-title">Flaggor</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-6">
                                            <div class="custom-control custom-checkbox mb-2">
                                                <input type="checkbox" class="custom-control-input" id="chk-hidden-all-cards" v-model="stock.isHiddenFromAllCards" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-hidden-all-cards">Produkten är gömd från alla kort</label>
                                            </div>
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox" class="custom-control-input" id="chk-show-all-cards" v-model="stock.show_on_all_cards" :disabled="!hasPermission('red_edit_products_extended')">
                                                <label class="custom-control-label" for="chk-show-all-cards">Produkten visas på alla kort</label>
                                            </div>
                                            <div class="text-muted" v-if="show_on_all_cards_limit">Visas på alla kort med försäljningspris: {{ show_on_all_cards_limit.min }} - {{ show_on_all_cards_limit.max }} kr</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="card">
                                <div
                                    class="card-header header-elements-inline"
                                    :class="[(stock.isStruct || (stock.struct_members && stock.struct_members.length > 0) || (stock.member_structs && stock.member_structs.length > 0) ? 'bg-info text-white' : 'bg-light')]"
                                >
                                    <h5 class="card-title">Strukturartikel</h5>
                                </div>
                                <div class="card-body">
                                    <div class="alert alert-danger" v-if="(stock.isStruct || (stock.struct_members && stock.struct_members.length > 0)) && (stock.member_structs && stock.member_structs.length > 0)">
                                        <span class="font-weight-semibold">VARNING!</span> En produkt kan inte vara en strukturartikel och samtidigt ingå i en annan strukturartikel!
                                    </div>
                                    <div class="form-group mb-0">
                                        <div class="custom-control custom-checkbox font-weight-semibold">
                                            <input type="checkbox" class="custom-control-input" id="chk-60" v-model="stock.isStruct" :true-value="1" :false-value="0">
                                            <label class="custom-control-label" for="chk-60">Denna produkt är en strukturartikel</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-if="stock.isStruct || (stock.struct_members && stock.struct_members.length > 0)">
                                    <h5>Denna strukturartikel består av:</h5>
                                    <div class="row">
                                        <div class="col-xl-4" style="max-width: 150px;">
                                            <label>Antal</label>
                                        </div>
                                        <div class="col">
                                            <label>Produkt</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2 flex-nowrap" v-for="(member, m_index) in stock.struct_members" :key="'sm-' + m_index">
                                        <div class="col-xl-4" style="max-width: 150px;">
                                            <ValidationProvider tag="div" class="form-group mb-0" :vid="'struct_members.' + m_index + '.Quantity'" name="Antal" rules="" v-slot="{ errors }">
                                                <div class="input-group">
                                                    <input type="text" class="form-control" v-model="member.Quantity">
                                                    <span class="input-group-append">
                                                        <span class="input-group-text">st</span>
                                                    </span>
                                                </div>
                                                <span v-if="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col">
                                            <ValidationProvider tag="div" :vid="'struct_members.' + m_index + '.ProdID'" name="Produkt" rules="" v-slot="{ errors }">
                                                <div class="form-group mb-0 d-flex flex-nowrap">
                                                    <a
                                                        class="btn btn-block flex-grow-1"
                                                        :class="{ 'btn-light': !member.isStruct, 'btn-danger-200': member.isStruct }"
                                                        style="text-align: left; overflow:hidden;"
                                                        :href="'/products/'+member.ProdID"
                                                        target="_blank"
                                                    >
                                                        {{ member.ProdID }}: {{ member.ProdName }}{{ (member.ProdQty || member.ProdVariant ? ' / ' + member.ProdQty + member.ProdVariant : '') }}
                                                    </a>
                                                    <button type="button" class="btn btn-danger btn-sm ml-3" @click="deleteStructMember(m_index)"><i class="icon-trash"></i></button>
                                                </div>
                                                <span v-if="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="row mb-2 flex-nowrap">
                                        <div class="col-xl-4 col-form-label" style="max-width: 150px;">
                                            Lägg till:
                                        </div>
                                        <div class="col">
                                            <product-filter
                                                :multiple="false"
                                                :value="new_struct_member"
                                                @option:selected="addStructMember"
                                                placeholder="Välj produkt att lägga till..."
                                            >
                                            </product-filter>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body" v-if="stock.member_structs && stock.member_structs.length > 0">
                                    <h5>Denna artikel ingår i:</h5>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <label>Produkt</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2" v-for="(member, m_index) in stock.member_structs" :key="'ms-' + m_index">
                                        <div class="col-xl-12">
                                            <div class="form-group mb-0">
                                                <a class="btn btn-block btn-light" style="text-align: left; overflow:hidden; white-space:nowrap;" :href="'/products/'+member.ProdID" target="_blank">
                                                    {{ member.ProdID }}: {{ member.ProdName }} / {{ member.ProdSize }} / {{ member.ProdColor }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsavestock" type="button" @click="saveStock" :busy="busy" icon="icon-floppy-disk">SPARA</limitless-button>
            </div>
        </div>
        <div v-else class="text-danger">Kunde ej hämta data...</div>

        <b-modal id="modal_print_stocklabel" title="Skriv ut Lageretikett" @ok="printStockLabel" cancel-variant="light" cancel-title="Avbryt" ok-title="Skriv ut" key="modal_print_stocklabel">
            <ValidationObserver ref="stocklabelform" tag="div">
                <div class="row">
                    <div class="col-sm-12">
                        <ValidationProvider vid="printer_tag" name="Skrivare" rules="required" v-slot="{ errors }">
                            <div class="form-group" :class="{ 'has-error': errors[0] }">
                                <label class="font-weight-semibold" for="stocklabel_printer_tag">Välj skrivare</label><br>
                                <v-select
                                    id="stocklabel_printer_tag"
                                    :options="stocklabel_printers"
                                    :reduce="opt => opt.tag"
                                    label="name"
                                    placeholder="-- Välj skrivare --"
                                    v-model="stock_label.printer_tag"
                                ></v-select>
                                <span class="validation-invalid-label">{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
                        <div class="row">
                            <div class="col-sm-4">
                                <ValidationProvider vid="prod_quantity" name="Antal produkter" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label class="font-weight-semibold" for="stocklabel_prod_quantity">Antal produkter</label><br>
                                        <input type="number" id="stocklabel_prod_quantity" class="form-control" min="1" step="1" v-model="stock_label.prod_quantity">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-8">
                        <div class="row">
                            <div class="col-sm-4">
                                <ValidationProvider vid="quantity" name="Antal etiketter" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label class="font-weight-semibold" for="stocklabel_quantity">Antal etiketter</label><br>
                                        <input type="number" id="stocklabel_quantity" class="form-control" min="1" step="1" v-model="stock_label.quantity">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import ProductFilter from '@components/Filters/ProductFilter';
import getError from '@services/ErrorHelper';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import vSelect from 'vue-select';
import PrinterRepository from '@services/repositories/Printer/PrinterRepository';
import ProductRepository from '@services/repositories/Product/ProductRepository';
import Cookies from 'js-cookie';
import { hasPermission, hasRole } from '@services/Helpers';
import ProductTypeFilter from '@components/Filters/ProductTypeFilter.vue';
import ProductCodesTypesFilter from '@components/Filters/ProductCodesTypesFilter.vue';

const productRepository = new ProductRepository();
const SUBPRODUCT_SELECTION_PRODUCT_TYPE_IDS = [2, 3, 6];

export default {
    name: 'ProductEditStock',
    components: {
        ProductCodesTypesFilter,
        ProductTypeFilter,
        VDatePicker,
        vSelect,
        LimitlessButton,
        ProductFilter,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy: true,
        stock: null,
        show_on_all_cards_limit: null,
        stock_label: {
            printer_tag: null,
            quantity: 1,
            prod_quantity: '',
        },
        stocklabel_printers: [],
        new_struct_member: null,
    }),
    created() {
        this.getPrinters();
        this.getStock();
    },
    watch: {
        'stock.useStockCounts': function stockUseStockCounts(newVal) {
            if (newVal > 0) {
                this.stock.isNonStockItem = 0;
            }
        },
    },
    methods: {
        hasPermission,
        hasRole,
        async getStock() {
            await apiClient.get('/vue/products/' + this.id + '/stock')
                .then((response) => {
                    if (response.data.product) {
                        this.stock = response.data.product;
                        this.show_on_all_cards_limit = response.data.show_on_all_cards_limit;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy = false;
                });
        },
        async saveStock() {
            const isValid = await this.$refs.stockform.validate();
            if (isValid) {
                this.busy = true;
                const post = { ...this.stock };
                await apiClient.post('/vue/products/' + this.id + '/stock', post)
                    .then((response) => {
                        if (response.data.product) {
                            this.stock = response.data.product;
                        }
                        this.$refs.btnsavestock.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.stockform.setErrors(parsederror);
                        }
                        this.$refs.btnsavestock.triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            }
        },
        async getPrinters() {
            const client = new PrinterRepository();
            client.where('media', 'freightlabel')
                .where('language', 'zpl')
                .orderBy('name')
                .orderDirection('ASC')
                .setPerPage(999999);

            if (!this.hasRole('super-admin')) {
                client.where('is_dev', 0);
            }

            const response = await client.run();
            this.stocklabel_printers = response.data;
        },
        showModalStockLabel() {
            const printerTag = Cookies.get('stocklabel_printer');
            if (printerTag) {
                this.stock_label.printer_tag = printerTag;
            }
            this.stock_label.quantity = 1;
            this.stock_label.prod_quantity = '';
            this.$root.$bvModal.show('modal_print_stocklabel');
        },
        async printStockLabel(event) {
            event.preventDefault();
            const isValid = await this.$refs.stocklabelform.validate();
            if (isValid) {
                Cookies.set('stocklabel_printer', this.stock_label.printer_tag, { expires: 365 });
                apiClient.get('/api/printer/print/stocklabel/' + this.id + '/' + this.stock_label.quantity + '/' + this.stock_label.printer_tag + '/lageretikett_stor.zpl', {
                    params: {
                        prod_quantity: this.stock_label.prod_quantity,
                    },
                })
                    .then(() => {
                        this.$root.$bvModal.hide('modal_print_stocklabel');
                    });
            }
        },
        async adjustStock(warehouse) {
            const newStock = this.$refs['new-warehouse-stock-' + warehouse].value;
            const { value: comment } = await this.$swal.fire({
                title: 'Kommentar till saldoändring',
                input: 'text',
                inputPlaceholder: 'Kommentar',
                showCancelButton: true,
                inputValidator: (value) => new Promise((resolve) => {
                    if (!value) {
                        resolve('Kommentar måste anges!');
                    }
                    resolve();
                }),
            });
            if (comment && newStock) {
                const post = {
                    adjustments: [
                        {
                            sku: this.id,
                            quantity: newStock,
                            comment,
                        },
                    ],
                };
                await apiClient.post('/vue/products/stock/adjust', post)
                    .then(() => {
                        this.getStock();
                        this.$refs['btnadjustwarehousestock-' + warehouse].triggerSaved();
                        this.$refs['new-warehouse-stock-' + warehouse].value = '';
                    })
                    .catch(() => {
                        this.$refs['btnadjustwarehousestock-' + warehouse].triggerFailed();
                    })
                    .finally(() => {
                        this.busy = false;
                    });
            } else {
                this.$refs['btnadjustwarehousestock-' + warehouse].triggerFailed();
            }
        },
        deleteStructMember(index) {
            this.$delete(this.stock.struct_members, index);
        },
        async addStructMember(product) {
            if (product !== null) {
                const existing = this.stock.struct_members.find((p) => p.ProdID === product.ProdID);
                if (!existing) {
                    const prod = await productRepository.getById(product.ProdID);
                    if (prod) {
                        this.stock.struct_members.push({
                            ProdID: prod.ProdID,
                            ProdSupplierSKU: prod.ProdSupplierSKU,
                            ProdName: prod.ProdName,
                            ProdNameWeb: prod.ProdNameWeb,
                            ProdQty: prod.ProdQty,
                            ProdVariant: prod.ProdVariant,
                            Quantity: prod.Quantity,
                            isStruct: prod.isStruct,
                        });
                    }
                }
                this.new_struct_member = null;
            }
        },
        prodTypeSelected(type) {
            this.stock.type = type;

            if (type.id !== 10) {
                this.stock.ProductCodeTypeID = null;
            }
            if (!SUBPRODUCT_SELECTION_PRODUCT_TYPE_IDS.includes(parseInt(type.id, 10))) {
                this.stock.no_of_subproducts = null;
            }

            if (!type.allowed_shipping_methods.includes('DPD')) {
                this.stock.allowed_deliv_types[1] = false;
            }
            if (!type.allowed_shipping_methods.includes('postoffice')) {
                this.stock.allowed_deliv_types[2] = false;
            }
            if (!type.allowed_shipping_methods.includes('postal')) {
                this.stock.allowed_deliv_types[8] = false;
            }
            if (!type.allowed_shipping_methods.includes('online')) {
                this.stock.allowed_deliv_types[4] = false;
            }

            if (type.allowed_shipping_methods.length === 1) {
                if (type.allowed_shipping_methods[0] === 'DPD') {
                    this.stock.allowed_deliv_types[1] = true;
                }
                if (type.allowed_shipping_methods[0] === 'postoffice') {
                    this.stock.allowed_deliv_types[2] = true;
                }
                if (type.allowed_shipping_methods[0] === 'postal') {
                    this.stock.allowed_deliv_types[8] = true;
                }
                if (type.allowed_shipping_methods[0] === 'online') {
                    this.stock.allowed_deliv_types[4] = true;
                }
            }
        },
    },
    computed: {
        uses_subproduct_selection() {
            return this.stock && SUBPRODUCT_SELECTION_PRODUCT_TYPE_IDS.includes(parseInt(this.stock.ProductTypeID, 10));
        },
    },
};

</script>
